const DEFAULT_RETURN_PATH = '/';

export function sanitizeReturnUrl(returnUrl, fallback = DEFAULT_RETURN_PATH) {
  if (!returnUrl || typeof returnUrl !== 'string') {
    return fallback;
  }

  let decoded = returnUrl.trim();
  try {
    decoded = decodeURIComponent(decoded);
  } catch {
    return fallback;
  }

  if (!decoded.startsWith('/') || decoded.startsWith('//')) {
    return fallback;
  }

  if (decoded.startsWith('/login') || decoded.startsWith('/forgot-password') || decoded.startsWith('/reset-password')) {
    return fallback;
  }

  return decoded;
}

export function buildLoginRedirectPath(location) {
  const returnUrl = `${location.pathname}${location.search}${location.hash || ''}`;
  return {
    pathname: '/login',
    search: `?returnUrl=${encodeURIComponent(returnUrl)}`,
  };
}

export function buildLoginHrefFromWindow() {
  const returnUrl = encodeURIComponent(
    `${window.location.pathname}${window.location.search}${window.location.hash || ''}`
  );
  return `/login?returnUrl=${returnUrl}`;
}

export function getLoginReturnPath(searchParams) {
  return sanitizeReturnUrl(searchParams.get('returnUrl'));
}
